import { fetchFromGql } from './fetch';
import type { GraphQLResponse } from './response';
import type { GqlRequestExtensions } from './types';

interface FetchJsonGqlArgs<GqlVariables = unknown> {
  query?: string;
  variables?: GqlVariables;
  extensions?: GqlRequestExtensions;
}

const getStringifiedBody = <GqlVariables = unknown>({
  query,
  variables,
  extensions,
}: FetchJsonGqlArgs<GqlVariables>) =>
  JSON.stringify({
    ...(!!query && { query }),
    ...(!!variables && { variables }),
    ...(!!extensions && { extensions }),
  });

export const fetchJsonGql = <ResponseData, GqlVariables = unknown>(
  args: FetchJsonGqlArgs<GqlVariables>
) =>
  fetchFromGql<GraphQLResponse<ResponseData>>({
    body: getStringifiedBody(args),
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
  });
